/**
 * @author Radek Liška <ing.radek.liska@gmail.com>
 * @copyright Ki-Wi Digital s.r.o.
 * @license
 * All Rights Reserved.
 * Unauthorized copying of this file is strictly prohibited.
 * Proprietary and confidential.
 */

// @ts-check

/**
 * Typ připojení zařízení k síti.
 * @enum {'Ethernet' | 'Wifi'}
 * @readonly
 */
const NetworkType = /** @type {const} */ ({
  /** Připojení přes pevné ethernet připojení. */
  Ethernet: 'Ethernet',
  /** Připojení přes bezdrátové Wi-Fi připojení. */
  Wifi: 'Wifi'
});

export default NetworkType;
